export default __webpack_public_path__ + "382d78901b45c16f4a80b02811ba9e1d.png";